module.exports = __webpack_public_path__ + "static/media/operating_icon.fc44a73b.svg";